module.exports = "/static-assets/_next/static/images/rainbowSeagull-6d0aace13c53318e2d35aeac5aabf1e6.gif";